// const STORAGE_KEY = 'storeStorage'; // 所有本项目的缓存都存在这里
export default {
    // key: mall 
    setItem(key, value, expire=10080) {
        localStorage.setItem(key, JSON.stringify({
            value: value,
            expire: new Date().getTime() + expire * 60000 // 转换为毫秒，60000毫秒/分钟
        }));
    },
    // 取某一个模块下的属性 (user下面的userName)
    getItem(key) {
        const item = JSON.parse(localStorage.getItem(key));
        if (item && item.expire && new Date().getTime() < item.expire) {
            return item.value;
        } else {
            this.removeItem(key);
            return null;
        }
    },
    removeItem(key) {
        localStorage.removeItem(key);
    }
}

// 使用
// this.$storage.setItem("eid", row.eid);
// this.$storage.getItem("eid");
// this.$storage.removeItem('eid');

